import { render } from "./noTradeClauseNotesDialog.vue?vue&type=template&id=3a909504"
import script from "./noTradeClauseNotesDialog.vue?vue&type=script&lang=js"
export * from "./noTradeClauseNotesDialog.vue?vue&type=script&lang=js"

import "./noTradeClauseNotesDialog.vue?vue&type=style&index=0&id=3a909504&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__